import { icons } from "assets/icons";
import { Content, Horizontal } from "gls/lib";
import React, { useState } from "react";
import { classes, style } from "typestyle";
import { DropdownMenu } from "./DropdownMenu";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { colours } from "styling/colours";

type DropdownProps = {
  className?: string;
  menuItems: React.ReactNode;
  title: string | React.ReactNode;
  id?: string;
  ariaLabel: string;
  hideArrow?: boolean;
};

export const Dropdown = ({
  title,
  className,
  menuItems: dropdownItems,
  id,
  ariaLabel,
  hideArrow = false
}: DropdownProps) => {

  const ref = React.createRef<HTMLDivElement>();
  useOutsideAlerter(ref, () => setShowing(false));
  const [showing, setShowing] = useState(false);

  return (
    <div
      ref={ref}
      className={classes(
        className,
        style({
          position: "relative",
          lineHeight: "22px",
          fontSize: "14px !important",
          cursor: "pointer",
        })
      )}
    >
      <Horizontal
        id={id}
        spacing={8}
        role="button"
        tabIndex={0}
        verticalAlign="center"
        horizontalAlign="right"
        onClick={() => setShowing(true)}
        onKeyDown={e => {
          if (e.key === 'Enter')
            setShowing(true)
          if (e.key === 'Escape')
            setShowing(false)
        }}
        className={titleStyle}
      >
        <Content
          className={style({
            fontFamily: "MuseoSlab",
            fontSize: "14px",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          })}
        >
          {title}
        </Content>
        {!hideArrow && (
          <icons.ArrowDownIcon
            aria-label={ariaLabel}
            className={style({
              display: "inline-block",
            })}
            height={10}
            width={10}
            id="arrow-icon"
          />
        )}
      </Horizontal>
      {showing && (
        <DropdownMenu onClose={() => setShowing(false)}>
          {dropdownItems}
        </DropdownMenu>
      )}
    </div>
  );
};

const titleStyle = style({
  color: colours.secondaryText,
  $nest: {
    "svg g line": {
      stroke: colours.secondaryText,
    },
    "&:hover": {
      color: colours.secondary,
      $nest: {
        "svg g line": {
          stroke: colours.secondary,
        },
      },
    },
    "&:focus-visible": {
      outline: `1px solid ${colours.secondary}`
    }
  },
})